import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    markdown: {
        '& p': {
            margin: '0 0 8px 0'
        },
        '& p:last-child': {
            marginBottom: 0
        },
        '& ul, & ol': {
            margin: '8px 0',
            paddingLeft: 20
        },
        '& li': {
            marginBottom: 4
        },
        '& code': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            padding: '2px 4px',
            borderRadius: 4,
            fontSize: '0.9em'
        },
        '& pre': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            padding: 12,
            borderRadius: 8,
            overflowX: 'auto',
            margin: '8px 0'
        },
        '& pre code': {
            backgroundColor: 'transparent',
            padding: 0
        },
        '& a': {
            color: 'var(--ion-color-primary)',
            textDecoration: 'underline'
        },
        '& strong': {
            fontWeight: 600
        },
        '& blockquote': {
            margin: '8px 0',
            paddingLeft: 12,
            borderLeft: '3px solid rgba(0, 0, 0, 0.2)'
        }
    }
});

interface MarkdownMessageProps {
    content: string;
}

export const MarkdownMessage: FC<MarkdownMessageProps> = ({ content }) => {
    const classes = useStyles();

    const components = {
        a: ({ children, ...props }: any) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        )
    };

    return (
        <div className={classes.markdown}>
            {/* remark-gfm autolinks bare URLs — the model often emits them un-bracketed, and plain
                CommonMark would render them as inert text */}
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{content}</ReactMarkdown>
        </div>
    );
};
